// extracted by mini-css-extract-plugin
export var activityContainer = "_no-0";
export var typingIndicatorContainer = "_no-1";
export var typingIndicatorDot = "_no-2";
export var wave = "_no-3";